/**
 * Notification sounds using Web Audio API.
 * No external audio files needed.
 */

let ctx = null;

function getContext() {
  if (!ctx) {
    try {
      ctx = new (window.AudioContext || window.webkitAudioContext)();
    } catch (e) {
      return null;
    }
  }
  return ctx;
}

function tone(c, freq, dur, when = 0, type = 'sine', volMult = 1) {
  const osc = c.createOscillator();
  const gain = c.createGain();
  osc.type = type;
  osc.frequency.value = freq;
  const vol = 0.4 * volMult;
  gain.gain.setValueAtTime(0, c.currentTime + when);
  gain.gain.linearRampToValueAtTime(vol, c.currentTime + when + 0.01);
  gain.gain.exponentialRampToValueAtTime(0.001, c.currentTime + when + dur);
  osc.connect(gain).connect(c.destination);
  osc.start(c.currentTime + when);
  osc.stop(c.currentTime + when + dur + 0.05);
}

/** C4 Double Ding — two sine tones */
export function playCommentSound() {
  if (localStorage.getItem('notif_sound_muted') === '1') return;
  const c = getContext();
  if (!c) return;
  if (c.state === 'suspended') {
    c.resume().catch(() => {});
  }
  tone(c, 1318, 0.2, 0, 'sine');
  tone(c, 1568, 0.3, 0.18, 'sine');
}

/** B6 Marimba — four ascending triangle tones */
export function playBroadcastSound() {
  if (localStorage.getItem('notif_sound_muted') === '1') return;
  const c = getContext();
  if (!c) return;
  if (c.state === 'suspended') {
    c.resume().catch(() => {});
  }
  [523, 659, 784, 1046].forEach((f, i) => {
    tone(c, f, 0.3, i * 0.12, 'triangle', 0.7);
  });
}

export function isMuted() {
  return localStorage.getItem('notif_sound_muted') === '1';
}

export function setMuted(muted) {
  if (muted) {
    localStorage.setItem('notif_sound_muted', '1');
  } else {
    localStorage.removeItem('notif_sound_muted');
  }
}
